export interface Movie {
  id: number;
  title: string;
  category: 'movie' | 'tv' | 'anime' | 'variety';
  tags: string[];
  region: string;
  year: string;
  rating: number;
  director: string;
  actors: string[];
  description: string;
  longDescription: string;
  poster: string;
  banner: string;
  episodes?: string;
  duration?: string;
  isHot: boolean;
  isNew: boolean;
  updateInfo?: string;
}

export const allMovies: Movie[] = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'movie',
    tags: ['科幻', '冒险', '剧情'],
    region: '中国大陆',
    year: '2026',
    rating: 9.2,
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启长达2500年的流浪之旅。第三部继续讲述人类在宇宙中寻找新家园的壮丽史诗。',
    longDescription: '《流浪地球3》是中国科幻电影的里程碑系列最新力作。故事延续前作的宏大叙事，人类在经历木星危机后，继续在浩瀚宇宙中寻找新的希望。面对未知的宇宙危险和内部矛盾，人类必须团结一致，用智慧和勇气开辟通往未来的道路。影片以震撼的视觉特效、深刻的人文关怀和扣人心弦的剧情，再次展现了中国科幻电影的世界级水准。这一部中，地球面临前所未有的挑战——太阳系边缘的神秘粒子风暴正在吞噬一切。人类必须在有限时间内做出抉择：继续前行还是掉头返回？',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20featuring%20a%20giant%20planet%20Earth%20with%20massive%20thrusters%20in%20deep%20space%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20cosmic%20background%20with%20stars%2C%20warm%20orange%20and%20blue%20color%20grading%2C%20epic%20scale&width=600&height=840&seq=movie-poster-01&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20landscape%20of%20Earth%20floating%20in%20deep%20space%20with%20giant%20glowing%20thrusters%2C%20dramatic%20nebula%20background%2C%20starry%20cosmos%2C%20warm%20orange%20and%20teal%20color%20tones%2C%20cinematic%20scope%2C%20grand%20scale%2C%20atmospheric&width=1600&height=700&seq=movie-banner-01&orientation=landscape',
    isHot: true,
    isNew: true,
    duration: '148分钟',
    updateInfo: '2026-08-05更新',
  },
  {
    id: 2,
    title: '哪吒之魔童闹海',
    category: 'movie',
    tags: ['动画', '奇幻', '动作'],
    region: '中国大陆',
    year: '2025',
    rating: 9.5,
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '瀚墨'],
    description: '哪吒与敖丙在天劫后灵魂幸存，太乙真人用七色宝莲为二人重塑肉身。然而在重塑过程中遭遇重重困难，哪吒必须面对新的挑战，守护陈塘关和天下苍生。',
    longDescription: '《哪吒之魔童闹海》是国产动画电影的现象级续作。天劫之后，哪吒与敖丙的灵魂虽然保住了，但肉身即将魂飞魄散。太乙真人打算用七色宝莲为二人重塑肉身，然而在重塑的过程中却遇到了重重困难。与此同时，四海龙王联手对陈塘关发动了空前的大规模进攻，哪吒与敖丙的命运将何去何从？本片以精湛的3D动画技术、饱满的人物塑造和深刻的情感内核，再次刷新了国产动画的品质天花板。影片不仅有令人叹为观止的视觉奇观，更深入探讨了命运、成长与担当的主题。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20of%20mythological%20boy%20warrior%20with%20flaming%20hair%20and%20red%20silk%20ribbon%2C%20dynamic%20action%20pose%2C%20traditional%20Chinese%20art%20style%20blended%20with%20modern%203D%2C%20fiery%20background%2C%20dramatic%20lighting&width=600&height=840&seq=movie-poster-02&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Mythological%20Chinese%20animated%20landscape%20with%20floating%20mountains%20and%20traditional%20temples%2C%20epic%20battle%20scene%20with%20fire%20and%20water%20elements%2C%20cinematic%20lighting%2C%20warm%20red%20and%20gold%20tones%2C%20grand%20scale&width=1600&height=700&seq=movie-banner-02&orientation=landscape',
    isHot: true,
    isNew: false,
    duration: '110分钟',
    updateInfo: '2026-07-20更新',
  },
  {
    id: 3,
    title: '孤注一掷2',
    category: 'movie',
    tags: ['犯罪', '剧情', '悬疑'],
    region: '中国大陆',
    year: '2026',
    rating: 8.8,
    director: '申奥',
    actors: ['张艺兴', '金晨', '咏梅'],
    description: '境外网络诈骗团伙卷土重来，手段更加隐蔽和高科技化。中国警方与国际执法机构联手，展开一场跨越国界的反诈行动，深入虎穴揭开跨国犯罪网络。',
    longDescription: '《孤注一掷2》延续第一部的反诈主题，聚焦新型网络诈骗犯罪。随着AI技术的发展，诈骗手段也在不断升级。影片讲述了一支中国警察小队深入东南亚某国，与当地执法部门合作，追踪一个利用深度伪造和AI语音技术进行大规模诈骗的跨国犯罪集团。在这场智力与勇气的较量中，正义与邪恶的边界逐渐模糊，每个角色都面临道德和生存的考验。影片以紧张刺激的叙事节奏、真实震撼的案件还原和对人性的深刻洞察，成为年度必看的现实题材力作。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%20with%20dark%20moody%20atmosphere%2C%20silhouette%20figures%20behind%20computer%20screens%2C%20neon%20red%20and%20blue%20lighting%2C%20cyberpunk%20aesthetic%2C%20tense%20cinematic%20style&width=600&height=840&seq=movie-poster-03&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Dark%20cyberpunk%20cityscape%20at%20night%20with%20neon%20red%20and%20blue%20lights%2C%20computer%20server%20rooms%2C%20mysterious%20atmosphere%2C%20crime%20thriller%20aesthetic%2C%20cinematic%20composition&width=1600&height=700&seq=movie-banner-03&orientation=landscape',
    isHot: true,
    isNew: true,
    duration: '132分钟',
    updateInfo: '2026-08-01更新',
  },
  {
    id: 4,
    title: '庆余年第三季',
    category: 'tv',
    tags: ['古装', '剧情', '悬疑'],
    region: '中国大陆',
    year: '2026',
    rating: 9.3,
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明'],
    description: '范闲在经历了一系列惊心动魄的冒险后，逐渐揭开了自己的身世之谜。他必须在皇室权谋与江湖恩怨之间找到平衡，守护自己所珍视的一切。',
    longDescription: '《庆余年第三季》改编自猫腻同名小说，续写范闲在南庆朝廷和江湖中的传奇故事。第三季中，范闲深入调查母亲叶轻眉之死的真相，却发现背后隐藏着更大的阴谋。与此同时，北齐和东夷城的势力蠢蠢欲动，天下格局即将改写。范闲必须在朝堂之上运筹帷幄，在江湖之中快意恩仇，用自己的方式守护这个世界的和平与正义。本季制作全面升级，服化道精致考究，武打场面气势恢宏，剧情跌宕起伏，引人入胜。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20handsome%20warrior%20scholar%20in%20traditional%20hanfu%20robes%2C%20holding%20a%20sword%2C%20ancient%20Chinese%20palace%20background%2C%20ink%20wash%20painting%20style%2C%20elegant%20composition&width=600&height=840&seq=movie-poster-04&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20and%20landscape%20in%20ink%20wash%20painting%20style%2C%20misty%20mountains%2C%20traditional%20rooftops%2C%20elegant%20golden%20and%20warm%20gray%20tones%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=movie-banner-04&orientation=landscape',
    isHot: true,
    isNew: true,
    episodes: '全36集',
    updateInfo: '2026-08-06更新至第18集',
  },
  {
    id: 5,
    title: '唐朝诡事录之长安',
    category: 'tv',
    tags: ['古装', '悬疑', '奇幻'],
    region: '中国大陆',
    year: '2025',
    rating: 8.9,
    director: '柏杉',
    actors: ['杨旭文', '杨志刚', '郜思雯'],
    description: '大唐长安城内接连发生离奇案件，苏无名与卢凌风这对搭档再度联手，在繁华盛世的背后探寻不为人知的诡异真相。',
    longDescription: '《唐朝诡事录之长安》延续了前作的精良制作，将故事背景搬到了更为壮阔的大唐都城长安。在万国来朝的盛世景象之下，一系列匪夷所思的诡异案件悄然发生。从皇宫内院到市井小巷，从名门望族到江湖异人，每一个案件都牵扯出一段不为人知的历史秘辛。苏无名凭借其过人的推理能力和对奇门异术的了解，与武功高强的卢凌风并肩作战，一步步揭开笼罩在长安城上的重重迷雾。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20Tang%20dynasty%20mystery%20drama%20poster%20with%20two%20detectives%20in%20traditional%20robes%2C%20ancient%20city%20night%20scene%2C%20lanterns%2C%20mysterious%20atmosphere%2C%20dark%20and%20gold%20color%20scheme&width=600&height=840&seq=movie-poster-05&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Ancient%20Tang%20dynasty%20Chinese%20city%20at%20night%20with%20red%20lanterns%2C%20traditional%20architecture%2C%20misty%20atmosphere%2C%20mysterious%20mood%2C%20warm%20golden%20and%20dark%20tones%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=movie-banner-05&orientation=landscape',
    isHot: false,
    isNew: true,
    episodes: '全40集',
    updateInfo: '2026-07-25更新',
  },
  {
    id: 6,
    title: '咒术回战 第三季',
    category: 'anime',
    tags: ['动作', '奇幻', '热血'],
    region: '日本',
    year: '2026',
    rating: 9.1,
    director: '朴性厚',
    actors: ['榎木淳弥', '内田雄马', '濑户麻沙美'],
    description: '虎杖悠仁与伙伴们面对更加强大的咒灵威胁，涉谷事件之后咒术界格局发生了翻天覆地的变化，宿傩的秘密逐渐浮出水面。',
    longDescription: '《咒术回战第三季》承接涉谷事变后的剧情，咒术界遭受重创后开始重建。虎杖悠仁在被判处死刑缓期执行的状态下，继续以咒术师的身份执行任务。与此同时，一个名为"死灭回游"的残酷咒术游戏在全球范围内展开，众多古代术士在现代苏醒，世界陷入前所未有的混乱。虎杖和伙伴们必须在这场生死游戏中存活下来，并寻找终结这一切的方法。宿傩的真正目的究竟是什么？五条悟能否重获自由？一切都将在第三季中揭晓。',
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20style%20with%20young%20warrior%20boy%20with%20pink%20hair%20in%20dynamic%20action%20pose%2C%20dark%20energy%20surrounding%2C%20urban%20Tokyo%20background%2C%20vibrant%20anime%20art%20style%2C%20dramatic%20composition&width=600&height=840&seq=movie-poster-06&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Anime%20style%20urban%20Tokyo%20cityscape%20at%20night%20with%20supernatural%20energy%20effects%2C%20dark%20purple%20and%20red%20auras%2C%20dynamic%20composition%2C%20cinematic%20anime%20art%20style&width=1600&height=700&seq=movie-banner-06&orientation=landscape',
    isHot: true,
    isNew: true,
    episodes: '更新中',
    updateInfo: '2026-08-07更新至第5集',
  },
  {
    id: 7,
    title: '鬼灭之刃 无限城篇',
    category: 'anime',
    tags: ['动作', '奇幻', '热血'],
    region: '日本',
    year: '2025',
    rating: 9.4,
    director: '外崎春雄',
    actors: ['花江夏树', '鬼头明里', '下野纮'],
    description: '炭治郎与鬼杀队深入无限城，与鬼舞辻无惨展开最终决战。在这场命运的对决中，无数英雄将献出生命，只为迎接黎明的到来。',
    longDescription: '《鬼灭之刃无限城篇》作为整个系列的最终篇章，将炭治郎与鬼舞辻无惨的宿命对决推向了最高潮。无限城是一座由鬼舞辻无惨用血鬼术建造的异空间堡垒，鬼杀队的剑士们分散在城内各处，与上弦之鬼展开一对一的生死搏斗。每一场战斗都是信念与意志的较量，每一个牺牲都承载着对黎明的期盼。炭治郎能否完成祢豆子变回人类的愿望？千年的人鬼之争将在此画上句号。',
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20of%20demon%20slayer%20with%20green%20checkered%20haori%2C%20water%20breathing%20sword%20technique%20visual%20effects%2C%20dark%20mansion%20background%2C%20dramatic%20anime%20art%20style&width=600&height=840&seq=movie-poster-07&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Anime%20style%20dark%20infinite%20castle%20interior%20with%20floating%20platforms%2C%20traditional%20Japanese%20architecture%2C%20moonlight%2C%20mysterious%20atmosphere%2C%20cinematic%20anime%20composition&width=1600&height=700&seq=movie-banner-07&orientation=landscape',
    isHot: true,
    isNew: false,
    episodes: '全11集',
    updateInfo: '2026-06-15更新',
  },
  {
    id: 8,
    title: '乘风破浪的姐姐 第六季',
    category: 'variety',
    tags: ['音乐', '竞技', '真人秀'],
    region: '中国大陆',
    year: '2026',
    rating: 8.5,
    director: '晏吉',
    actors: ['宁静', '那英', '王心凌'],
    description: '30位30+姐姐重返舞台，用实力证明年龄只是数字。新一季赛制全面升级，更加残酷的淘汰机制让每一位姐姐都必须全力以赴。',
    longDescription: '《乘风破浪的姐姐第六季》汇集了来自演艺圈、音乐圈、体育圈的30位30+女性，她们将在为期三个月的封闭训练和激烈竞演中，用汗水和才华重新定义"姐姐"的力量。本季赛制全新升级，引入"联盟对抗"模式，姐姐们需要组建团队并进行多轮公演对决。除了精彩的舞台表演，节目中展现的女性互助、突破自我的精神内核，更是打动了无数观众。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20multiple%20elegant%20women%20in%20stunning%20stage%20costumes%2C%20spotlight%20effects%2C%20glamorous%20stage%20setting%2C%20golden%20and%20pink%20color%20tones&width=600&height=840&seq=movie-poster-08&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Grand%20stage%20with%20brilliant%20lighting%20and%20spotlights%2C%20concert%20atmosphere%2C%20golden%20and%20warm%20tones%2C%20entertainment%20show%20aesthetic%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=movie-banner-08&orientation=landscape',
    isHot: true,
    isNew: true,
    episodes: '更新中',
    updateInfo: '2026-08-06更新至第8期',
  },
  {
    id: 9,
    title: '封神第二部',
    category: 'movie',
    tags: ['奇幻', '古装', '战争'],
    region: '中国大陆',
    year: '2025',
    rating: 8.7,
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤'],
    description: '殷商大军兵临西岐，姜子牙率昆仑仙人驰援。姬发在绝境中觉醒，率领西岐军民以凡人之躯对抗神明之力，展开一场保卫家园的史诗之战。',
    longDescription: '《封神第二部》承接第一部的剧情，殷商太师闻仲率领邓婵玉和魔家四将等大军征伐西岐。面对拥有通天法力的殷商大军，姜子牙携昆仑众仙前来相助，但阐教和截教之间的恩怨也逐渐浮出水面。姬发在师父和兄弟的牺牲中逐渐领悟"天下共主"的真正含义，带领西岐军民以不屈的意志对抗强敌。影片以宏大壮阔的战争场面、精细入微的特效制作和深刻的人物刻画，将中国神话史诗推向新的高度。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%20with%20warriors%20in%20ancient%20armor%2C%20mythical%20creatures%2C%20battle%20scene%2C%20dark%20dramatic%20sky%2C%20cinematic%20Chinese%20fantasy%20art&width=600&height=840&seq=movie-poster-09&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20battlefield%20with%2C%20warriors%20in%20armor%2C%20mythical%20creatures%20in%20the%20sky%2C%20dramatic%20stormy%20weather%2C%20cinematic%20wide%20shot%2C%20dark%20and%20gold%20tones&width=1600&height=700&seq=movie-banner-09&orientation=landscape',
    isHot: false,
    isNew: false,
    duration: '136分钟',
    updateInfo: '2026-05-10更新',
  },
  {
    id: 10,
    title: '好搭档',
    category: 'tv',
    tags: ['爱情', '都市', '职场'],
    region: '韩国',
    year: '2026',
    rating: 8.6,
    director: '金哲圭',
    actors: ['张娜拉', '南志铉', '金俊翰'],
    description: '一位资深离婚律师与一位年轻热血的律师组成搭档，在办理各种离婚案件的过程中，两人也从互相看不顺眼到建立深厚友谊。',
    longDescription: '《好搭档》是2026年备受好评的韩国律政剧。故事围绕两位性格迥异的女律师展开：车恩京是业界知名的明星离婚律师，冷静理性、追求效率；韩宥利则是刚入行的热血新人，充满理想主义和对正义的执着。两人被安排成为搭档后，在共同处理形形色色的离婚案件过程中，不断碰撞、磨合，逐渐理解彼此并建立了超越职场的情谊。剧集以温暖细腻的笔触描绘了现代人的婚姻困境和女性成长，既有法庭上的唇枪舌战，也有生活中的温情时刻。',
    poster: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20with%20two%20professional%20women%20lawyers%20in%20suits%2C%20law%20office%20background%2C%20warm%20professional%20atmosphere%2C%20clean%20modern%20Korean%20drama%20style&width=600&height=840&seq=movie-poster-10&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20law%20office%20interior%20with%20large%20windows%2C%20warm%20natural%20lighting%2C%20professional%20atmosphere%2C%20clean%20modern%20aesthetic%2C%20Seoul%20cityscape%20view&width=1600&height=700&seq=movie-banner-10&orientation=landscape',
    isHot: false,
    isNew: true,
    episodes: '全16集',
    updateInfo: '2026-07-28更新',
  },
  {
    id: 11,
    title: '间谍过家家 第二季',
    category: 'anime',
    tags: ['喜剧', '日常', '动作'],
    region: '日本',
    year: '2025',
    rating: 9.0,
    director: '古桥一浩',
    actors: ['江口拓也', '种崎敦美', '早见沙织'],
    description: '间谍父亲、杀手母亲、读心术女儿——这个虚假却又温馨的家庭继续上演惊险又搞笑的日常，新任务和新角色让故事更加精彩。',
    longDescription: '《间谍过家家第二季》继续讲述福杰一家的奇妙冒险。劳埃德·福杰（代号"黄昏"）作为西国最强间谍，为了执行维护和平的秘密任务"枭"，与杀手约尔和拥有读心能力的阿尼亚组建了临时家庭。第二季中，福杰一家面临更多危险的任务和考验，邦德狗狗的加入让这个家庭更加完整。阿尼亚的学校生活也变得更加丰富多彩，新的同学和老师为故事增添了更多笑料。这部作品以精妙的叙事平衡了谍战紧张感与家庭温馨感，是近年来最出色的动漫之一。',
    poster: 'https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20family%20of%20three%20in%20formal%20attire%2C%20father%20mother%20and%20pink-haired%20daughter%2C%20spy%20theme%2C%20clean%20anime%20art%20style%2C%20pastel%20colors&width=600&height=840&seq=movie-poster-11&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Anime%20style%20European%20city%20street%20with%20cobblestone%2C%20warm%20afternoon%20sunlight%2C%20charming%20cafe%20buildings%2C%20peaceful%20atmosphere%2C%20vibrant%20anime%20art&width=1600&height=700&seq=movie-banner-11&orientation=landscape',
    isHot: false,
    isNew: false,
    episodes: '全25集',
    updateInfo: '2026-04-20更新',
  },
  {
    id: 12,
    title: '奔跑吧 第十四季',
    category: 'variety',
    tags: ['户外', '竞技', '真人秀'],
    region: '中国大陆',
    year: '2026',
    rating: 8.2,
    director: '姚译添',
    actors: ['李晨', '郑恺', '沙溢', '白鹿'],
    description: '跑男团继续全国各地的奔跑之旅，全新游戏环节和飞行嘉宾带来更多欢笑。本季主题"城市探索"，带观众领略不同城市的独特魅力。',
    longDescription: '《奔跑吧第十四季》以"城市探索"为主题，跑男团成员们将走遍全国各大特色城市，在充满地方文化特色的游戏挑战中展开激烈角逐。每一期节目都深度融入当地的历史文化和风土人情，既有令人捧腹的搞笑游戏环节，也有触动心弦的温情互动。新一季邀请到了众多重量级飞行嘉宾，与跑男团成员碰撞出意想不到的化学反应。节目在欢笑中传递积极向上的生活态度，是全家老少都能一起观看的优质综艺。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20celebrities%20running%20outdoors%2C%20energetic%20atmosphere%2C%20bright%20sunlight%2C%20colorful%20casual%20clothing%2C%20cheerful%20expressions&width=600&height=840&seq=movie-poster-12&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Bright%20outdoor%20park%20scene%20with%20green%20grass%20and%20blue%20sky%2C%20energetic%20fun%20atmosphere%2C%20summer%20vibe%2C%20colorful%20setting%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=movie-banner-12&orientation=landscape',
    isHot: false,
    isNew: false,
    episodes: '更新中',
    updateInfo: '2026-08-02更新至第10期',
  },
  {
    id: 13,
    title: '沙丘3',
    category: 'movie',
    tags: ['科幻', '冒险', '剧情'],
    region: '美国',
    year: '2026',
    rating: 8.9,
    director: '丹尼斯·维伦纽瓦',
    actors: ['提莫西·查拉梅', '赞达亚', '弗洛伦斯·皮尤'],
    description: '保罗·厄崔迪斯在成为宇宙皇帝后，面临来自各大家族的反抗。他必须在权力与信仰之间做出选择，而沙丘星球的秘密仍在等待被完全揭开。',
    longDescription: '《沙丘3》继续保罗·厄崔迪斯的传奇故事。在成为已知宇宙的皇帝后，保罗发起的圣战席卷了整个银河系，数十亿人在这场战争中丧生。面对自己引发的浩劫，保罗陷入了深深的矛盾：他预见了更可怕的未来，却不知如何避免。与此同时，各大家族暗中联合，密谋推翻厄崔迪斯家族的统治。弗雷曼人的信仰与保罗的真实意图之间也出现了裂痕。沙丘星球阿拉基斯的地下深处，古老的秘密正在苏醒。',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20Dune%20movie%20poster%20with%20desert%20warrior%20in%20still%20suit%2C%20giant%20sandworm%2C%20golden%20desert%20landscape%2C%20cinematic%20composition%2C%20dramatic%20lighting&width=600&height=840&seq=movie-poster-13&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Vast%20golden%20desert%20landscape%20with%20dramatic%20dunes%2C%20orange%20haze%20atmosphere%2C%20epic%20scifi%20scale%2C%20cinematic%20wide%20shot%2C%20warm%20sand%20tones&width=1600&height=700&seq=movie-banner-13&orientation=landscape',
    isHot: true,
    isNew: true,
    duration: '162分钟',
    updateInfo: '2026-08-03更新',
  },
  {
    id: 14,
    title: '狂飙2',
    category: 'tv',
    tags: ['犯罪', '剧情', '悬疑'],
    region: '中国大陆',
    year: '2026',
    rating: 9.0,
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    description: '全新的故事，全新的角色。一座沿海城市中，一场涉及政商勾结的大案浮出水面，刑警队长与检察官联手深入调查，揭开黑恶势力的保护伞。',
    longDescription: '《狂飙2》是现象级反黑剧的最新续作，虽然更换了故事和角色，但延续了第一季对社会现实的深刻洞察和对人性的复杂刻画。故事发生在东南沿海的临港市，一起看似普通的走私案，牵扯出一个盘踞当地二十年的黑恶势力集团。刑警队长赵建国与市检察官林雪组成专案组，在调查过程中发现该集团背后有着错综复杂的保护伞。正义与邪恶的较量、法律与权力的博弈，在这座繁华的海滨城市中激情上演。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20with%20police%20officer%20in%20uniform%2C%20dark%20rainy%20city%20street%2C%20neon%20lights%2C%20tense%20atmosphere%2C%20realistic%20Chinese%20drama%20style&width=600&height=840&seq=movie-poster-14&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20coastal%20city%20at%20night%20with%20skyscrapers%2C%20rainy%20streets%2C%20neon%20reflections%2C%20dramatic%20moody%20atmosphere%2C%20cinematic%20cityscape&width=1600&height=700&seq=movie-banner-14&orientation=landscape',
    isHot: true,
    isNew: true,
    episodes: '全30集',
    updateInfo: '2026-08-04更新',
  },
  {
    id: 15,
    title: '进击的巨人 最终季 完结篇',
    category: 'anime',
    tags: ['动作', '剧情', '黑暗'],
    region: '日本',
    year: '2025',
    rating: 9.3,
    director: '林祐一郎',
    actors: ['梶裕贵', '石川由依', '井上麻里奈'],
    description: '艾伦发动"地鸣"，无数超大型巨人踏平世界。曾经的战友们联合起来，为了阻止这场毁灭性的浩劫，做出了最后的抉择。',
    longDescription: '《进击的巨人最终季完结篇》为这部陪伴了观众十年的史诗巨作画上了句号。艾伦·耶格尔发动"地鸣"后，帕拉迪岛城墙中的数千万超大型巨人开始踏平岛外的世界。曾经并肩作战的调查兵团成员们——三笠、阿尔敏、让、科尼等人，联合马莱的战士队莱纳、皮克等，组成了最后的联合战队，前往阻止艾伦。在这场关乎人类命运的最终对决中，每个人都必须面对自己内心最深处的信念与矛盾。自由与生命、仇恨与宽恕的终极命题，在血与火的交织中得到残酷而深刻的回答。',
    poster: 'https://readdy.ai/api/search-image?query=Anime%20poster%20of%20Attack%20on%20Titan%20final%20season%20with%20giant%20titan%20figure%2C%20apocalyptic%20battle%20scene%2C%20dark%20dramatic%20sky%2C%20intense%20anime%20art%20style&width=600&height=840&seq=movie-poster-15&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Apocalyptic%20anime%20landscape%20with%20giant%20titans%20marching%2C%20destroyed%20city%2C%20dramatic%20red%20sky%2C%20epic%20scale%2C%20cinematic%20anime%20composition&width=1600&height=700&seq=movie-banner-15&orientation=landscape',
    isHot: true,
    isNew: false,
    episodes: '全2集（完结篇）',
    updateInfo: '2026-03-10更新',
  },
  {
    id: 16,
    title: '大侦探 第十一季',
    category: 'variety',
    tags: ['推理', '悬疑', '真人秀'],
    region: '中国大陆',
    year: '2026',
    rating: 9.0,
    director: '何忱',
    actors: ['何炅', '撒贝宁', '张若昀', '大张伟'],
    description: '明星大侦探们回归全新案件！本季每个案件都改编自真实事件，更加烧脑的推理和意想不到的反转，让观众跟随嘉宾一起找出真相。',
    longDescription: '《大侦探第十一季》作为国内最受欢迎的推理综艺，本季在案件设计上进行了全面升级。每个案件都取材自真实社会事件，在保留推理趣味性的同时，更加注重社会议题的深度探讨。何炅和撒贝宁的"双北"组合继续展现绝佳默契，张若昀的高能推理和大张伟的金句频出为节目增色不少。本季加入了全新的"嫌疑人交互式审讯"环节，嘉宾可以直接"审问"NPC角色获取线索，让推理过程更加真实刺激。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20variety%20show%20poster%20with%20detectives%20in%20suits%2C%20magnifying%20glass%2C%20dark%20mysterious%20room%2C%20suspense%20atmosphere%2C%20elegant%20detective%20theme&width=600&height=840&seq=movie-poster-16&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20room%20with%20bookshelves%2C%20warm%20lamp%20light%2C%20vintage%20furniture%2C%20clue%20board%20with%20photos%2C%20suspenseful%20atmosphere%2C%20cinematic%20interior&width=1600&height=700&seq=movie-banner-16&orientation=landscape',
    isHot: false,
    isNew: true,
    episodes: '更新中',
    updateInfo: '2026-08-05更新至第6期',
  },
];

export const getMoviesByCategory = (category: string): Movie[] => {
  return allMovies.filter(m => m.category === category);
};

export const getHotMovies = (): Movie[] => {
  return allMovies.filter(m => m.isHot);
};

export const getNewMovies = (): Movie[] => {
  return allMovies.filter(m => m.isNew);
};

export const getMovieById = (id: number): Movie | undefined => {
  return allMovies.find(m => m.id === id);
};